import { IRegexDictionary } from '../../../interfaces/general.interface'

export const standardRegexes: IRegexDictionary = {
  numeric: /^-?\d*(\.|,)?\d*$/, // eslint-disable-line no-useless-escape
  boolean: /^$|^(1|0|yes|no|true|false|on|off|enabled|disabled)$/i, // eslint-disable-line no-useless-escape
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line no-useless-escape
}
